<template>
  <span class="dashboard-breadcrumb">
    <span v-for="item in items" :key="item.title">
      <span :class="{ 'grey-text': item.route != currentRouteName }">{{ item.title }}</span>
      <span v-if="item.children">
        <span class="grey-text"> > </span>
        <span v-for="it in item.children" :key="it.title">
          <span :class="{ 'grey-text': it.route != currentRouteName }">{{ it.title }}</span>
          <span v-if="it.children">
            <span class="grey-text"> > </span>
            <span v-for="gc in it.children" :key="gc.title">
              <span :class="{ 'grey-text': gc.route != currentRouteName }">{{ gc.title }}</span>
              <span v-if="gc.children">
                <span class="grey-text"> > </span>
                <span v-for="ggc in gc.children" :key="ggc.title">
                  <span :class="{ 'grey-text': ggc.route != currentRouteName }">{{ ggc.title }}</span>
                </span>
              </span>
            </span>
          </span>
        </span>
      </span>
    </span>
  </span>
</template>
<script>
export default {
  name: "DashboardBreadcrumb",
  props: {
    items: {
      required: true,
      type: Array
    }
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    }
  }
};
</script>
